import api from "../../api/api";
import API_URL from "../../api/url";
import axios from 'axios';

const SalonRequest = {

  salonList: (values) => api.get(`${API_URL.BASEURL}${API_URL.getSlonlist}`, {
    params: {
      salonType: values?.salonType,
      serviceType: values?.serviceType,
      status: values?.status,
      salonName: values?.salonName,
      page: values?.page,
      search: values?.search,
      type: values?.type
    }
  }),

  updatedSalonsList :(values) => api.get(`${API_URL.BASEURL}${API_URL.getUpdatedSalons}`, {
    params: {
      // salonType: values?.salonType,
      // serviceType: values?.serviceType,
      // status: values?.status,
      // salonName: values?.salonName,
      page: values?.page,
      search: values?.search,
      list: values?.list || 1,
    }
  }),

  salonServiceList: (values) => api.get(`${API_URL.BASEURL}${API_URL.getSalonServiceList}`, values),

  updateImgList: (values) => api.get(`${API_URL.BASEURL}${API_URL.updatedImageList}`,  {
    params: {
      // salonType: values?.salonType,
      // serviceType: values?.serviceType,
      // status: values?.status,
      // salonName: values?.salonName,
      page: values?.page,
      search: values?.search,
      list: values?.list || 1,
    }
  }),

  createSalonUser: (values) => api.post(`${API_URL.BASEURL}${API_URL.createSalon}`, values),
  uploadSaloonImage: (values) => api.post(`${API_URL.BASEURL}${API_URL.saloonImageUpload}`, values),
  createSalon: (values) => api.post(`${API_URL.BASEURL}${API_URL.createSalonUser}`, values),
  createSalonAddress: (values) => api.post(`${API_URL.BASEURL}${API_URL.createSalonAddress}`, values),
  updateSalon: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateSalon}`, values),
  updateSalonStatus: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateSalonStatus}`, values),
  approveSalon: (values) => api.post(`${API_URL.BASEURL}${API_URL.approveSalon}`, values),
  approveUpdateSalon :  (values) => api.post(`${API_URL.BASEURL}${API_URL.approveUpdateSalon}`, values),
  approveUpdateImage :  (values) => api.post(`${API_URL.BASEURL}${API_URL.approveUpdateImage}`, values),
  salonDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.getSalonDetail}?salonId=${id}`),

  salonCategory : (id) =>  api.get(`${API_URL.BASEURL}${API_URL.getsalonCategory}?salonId=${id}`) , 
  salonAppointment : (id) =>  api.get(`${API_URL.BASEURL}${API_URL.getSalonAppointment}?salonId=${id}`) , 
  salonCategoryServices : (id) => api.get(`${API_URL.BASEURL}${API_URL.getSalonCategoryServices}?categoryId=${id}`),
  



  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=salons`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default SalonRequest